module.exports = __webpack_public_path__ + "static/media/speaker.6dcb25bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/speaker.svg
// module id = 500
// module chunks = 0